/*
 AngularJS v1.8.3-build.3784+sha.05c65be8a
 (c) 2010-2020 Google LLC. http://angularjs.org
 License: MIT
*/
(function (n, e) {
    'use strict'; function m(d, k, l) {
        var a = l.baseHref(), h = d[0]; return function (f, b, c) {
            var d, g; c = c || {}; g = c.expires; d = e.isDefined(c.path) ? c.path : a; e.isUndefined(b) && (g = "Thu, 01 Jan 1970 00:00:00 GMT", b = ""); e.isString(g) && (g = new Date(g)); b = encodeURIComponent(f) + "=" + encodeURIComponent(b); b = b + (d ? ";path=" + d : "") + (c.domain ? ";domain=" + c.domain : ""); b += g ? ";expires=" + g.toUTCString() : ""; b += c.secure ? ";secure" : ""; b += c.samesite ? ";samesite=" + c.samesite : ""; c = b.length + 1; 4096 < c && k.warn("Cookie '" + f + "' possibly not set or overflowed because it was too large (" +
                c + " > 4096 bytes)!"); h.cookie = b
        }
    } e.module("ngCookies", ["ng"]).info({ angularVersion: "1.8.3-build.3784+sha.05c65be8a" }).provider("$cookies", [function () {
        var d = this.defaults = {}; this.$get = ["$$cookieReader", "$$cookieWriter", function (k, l) {
            return {
                get: function (a) { return k()[a] }, getObject: function (a) { return (a = this.get(a)) ? e.fromJson(a) : a }, getAll: function () { return k() }, put: function (a, h, f) { l(a, h, f ? e.extend({}, d, f) : d) }, putObject: function (a, d, f) { this.put(a, e.toJson(d), f) }, remove: function (a, h) {
                    l(a, void 0, h ? e.extend({},
                        d, h) : d)
                }
            }
        }]
    }]); m.$inject = ["$document", "$log", "$browser"]; e.module("ngCookies").provider("$$cookieWriter", function () { this.$get = m })
})(window, window.angular);
//# sourceMappingURL=angular-cookies.min.js.map